// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"220":"7501e9cd","389":"fd8f91e1","431":"3500fb07","640":"7408dc98","703":"d9dd2dfd"}[chunkId] + ".chunk.css";
};